document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] .ls-input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
  
  observeSidebarDrawerState()
  handleQuickView();
});


function handleQuickView(){
  const targetNode = document.querySelector('.quickshop');

   if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          setTimeout(() => {
            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
          }, 500);
        }
      }
    });

    const config = {
      childList: true,
      subtree: true   
    };

    observer.observe(targetNode, config);
  }
}

function observeSidebarDrawerState() {
  const targetNode = document.querySelector('.sidebar-drawer-container');

  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-sidebar-drawer-animation-state'
        ) {
          const currentState = targetNode.getAttribute('data-sidebar-drawer-animation-state');
          if (currentState === 'open') {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
            BSS_B2B.nt.initFunction();
            document.dispatchEvent(new Event("DOMContentLoaded"));
          }
        }
      }
    });

    observer.observe(targetNode, {
      attributes: true,
      attributeFilter: ['data-sidebar-drawer-animation-state']
    });
  }
}

// TE
const isCartPage = window.location.pathname === '/cart';
if(!isCartPage) {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".cart-mini-footer");
    const taxExWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper.bss-config-header");
    if (footerPrice && taxExWrapper) {
        footerPrice.prepend(taxExWrapper);
        handleTEBox();
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    if ($(".bss-b2b-vat-input-wrapper").length > 0) {
        handleTEBox();
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
  }, 100);
}

function handleTEBox(){
      const translations = BSS_B2B.te.teTranslations;
    const headerText = document.querySelector('.bss-b2b-translation-vat-form_header_text');
    if (headerText) {
      headerText.innerText = translations.form_header_text;
    }

    const subtitleText = document.querySelector('.bss-b2b-translation-vat-form_subtitle_text');
    if (subtitleText) {
      subtitleText.innerText = translations.form_subtitle_text;
    }

    const successMessages = [
      document.querySelector('.bss-b2b-translation-vat-form_success_message'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_uk'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_abn'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_gst'),
      document.querySelector('.bss-b2b-translation-vat-form_success_message_us_ein')
    ];

    successMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_success_message || '';
            break;
          case 1:
            msg.innerText = translations.form_success_message_uk || '';
            break;
          case 2:
            msg.innerText = translations.form_success_message_abn || '';
            break;
          case 3:
            msg.innerText = translations.form_success_message_gst || '';
            break;
          case 4:
            msg.innerText = translations.form_success_message_us_ein || '';
            break;
        }
      }
    });

    const errorMessages = [
      document.querySelector('.bss-b2b-translation-vat-form_error_message'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_uk'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_abn'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_gst'),
      document.querySelector('.bss-b2b-translation-vat-form_error_message_us_ein'),
      document.querySelector('.bss-b2b-translation-vat-form_validate_country_code_message')
    ];

    errorMessages.forEach((msg, index) => {
      if (msg) {
        switch (index) {
          case 0:
            msg.innerText = translations.form_error_message || '';
            break;
          case 1:
            msg.innerText = translations.form_error_message_uk || '';
            break;
          case 2:
            msg.innerText = translations.form_error_message_abn || '';
            break;
          case 3:
            msg.innerText = translations.form_error_message_gst || '';
            break;
          case 4:
            msg.innerText = translations.form_error_message_us_ein || '';
            break;
          case 5:
            msg.innerText = translations.form_validate_country_code_message || '';
            break;
        }
      }
    });

}
